import store from '@/store/'

export default {
  install(Vue) {
    Vue.prototype.$withLoading = async function(callback) {
      store.commit('app/START_LOADING')

      await callback()

      store.commit('app/END_LOADING')
    }
  }
}
